import { apiService } from './apiService'

export const propertyValuationCacheService = {
  fetchBatch(propertyIds) {
    return apiService.post('/api/property-valuations/batch', { propertyIds })
  },

  fetchDetail(propertyId) {
    return apiService.get(`/api/property-valuations/${encodeURIComponent(propertyId)}`)
  },

  refresh(propertyId) {
    return apiService.post(`/api/property-valuations/${encodeURIComponent(propertyId)}/refresh`, {})
  },
}
